import { Flow, Text } from 'bold-ui'
import { EvolucaoSubjetivo, EvolucaoSubjetivoCiap } from 'graphql/types.generated'
import { Fragment } from 'react'
import { naoRegistradoNesseAtendimento } from 'view/atendimentos/detail/historico/utils/utils-historico'

import MotivoConsultaBox from './MotivoConsultaBox'

export interface HistoricoSubjetivoPecPanelProps {
  evolucaoSubjetivo: EvolucaoSubjetivo
}

export default function HistoricoSubjetivoPecPanel(props: Readonly<HistoricoSubjetivoPecPanelProps>) {
  const { evolucaoSubjetivo } = props
  const descricaoEvolucaoSubjetivo = evolucaoSubjetivo?.descricao?.removeTags()
  const hasSubjetivo = descricaoEvolucaoSubjetivo || evolucaoSubjetivo?.ciaps

  const hasCiaps = evolucaoSubjetivo?.ciaps !== null && evolucaoSubjetivo?.ciaps !== undefined

  return (
    <Fragment>
      {hasSubjetivo ? (
        <Flow direction='vertical' gap={0.5}>
          {descricaoEvolucaoSubjetivo && <Text dangerouslySetInnerHTML={{ __html: evolucaoSubjetivo.descricao }} />}
          {hasCiaps && <MotivoConsultaBox subjetivoCiaps={evolucaoSubjetivo.ciaps as EvolucaoSubjetivoCiap[]} />}
        </Flow>
      ) : (
        <Text fontStyle='italic'>{naoRegistradoNesseAtendimento}</Text>
      )}
    </Fragment>
  )
}
